import React, { type ReactNode } from 'react'

import { Suggestion } from '@components/common/Suggestion'
import { useMediaQueryContext } from '@fourthwall/components'

import launchGuide from '../../assets/launch-guide.png'
import * as S from './LaunchStrategyRecommendation.styled'

type LaunchStrategyRecommendationProps = {
  title: string
  description: string
  buttonLabel?: string
  primaryImageSrc: string
  secondaryImageSrc: string
  imagesDescription: ReactNode
  onClick: () => void
  onDismiss: () => void
}

export const LaunchStrategyRecommendation = ({
  title,
  description,
  buttonLabel = 'Read the guide',
  primaryImageSrc,
  secondaryImageSrc,
  imagesDescription,
  onClick,
  onDismiss,
}: LaunchStrategyRecommendationProps) => {
  const media = useMediaQueryContext()

  return (
    <Suggestion
      analytics="readTheGuideUltimateLaunchGuide"
      title={title}
      description={description}
      buttonLabel={buttonLabel}
      sideContent={
        media.tablet ? (
          <S.ImagesContent>
            <S.PrimaryImage src={primaryImageSrc} />
            <S.SecondaryImage src={secondaryImageSrc} />
            <S.ImagesDescription>{imagesDescription}</S.ImagesDescription>
          </S.ImagesContent>
        ) : undefined
      }
      imageUrl={launchGuide}
      onButtonClick={onClick}
      onDismiss={onDismiss}
    />
  )
}
